import { AxiosGlobalFilters } from '../config';

function getEmpresaId() {
  const value = `; ${document.cookie}`;
  const parts = value.split('; companies=');
  if (parts.length !== 2) return undefined;
  try {
    return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()))?.id;
  } catch {
    return undefined;
  }
}

function headers() {
  const empresaId = getEmpresaId();
  return empresaId ? { EmpresaId: empresaId } : {};
}

export const SolicitacoesService = {
  listar: ({ status, almoxarifadoId, solicitanteId, dataInicial, dataFinal, page = 1, pageSize = 10 } = {}) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/solicitacoes-materiais',
      headers: headers(),
      params: {
        ...(status !== undefined && { status }),
        ...(almoxarifadoId && { almoxarifadoId }),
        ...(solicitanteId && { solicitanteId }),
        ...(dataInicial && { dataInicial }),
        ...(dataFinal && { dataFinal }),
        page,
        pageSize,
      },
    }),

  criar: ({ almoxarifadoId, siteId, solicitanteId, itens = [] }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: '/v1/solicitacoes-materiais',
      headers: headers(),
      data: { almoxarifadoId, siteId, solicitanteId, itens },
    }),

  excluir: ({ id }) =>
    AxiosGlobalFilters({ method: 'DELETE', url: `/v1/solicitacoes-materiais/${id}`, headers: headers() }),

  // Itens
  listarItens: ({ id }) =>
    AxiosGlobalFilters({ method: 'GET', url: `/v1/solicitacoes-materiais/${id}/itens`, headers: headers() }),

  adicionarItem: ({ id, materialId, quantidade, anomaliaId, compraMaterialItemId }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: `/v1/solicitacoes-materiais/${id}/itens`,
      headers: headers(),
      data: {
        materialId,
        quantidade,
        ...(anomaliaId && { anomaliaId }),
        ...(compraMaterialItemId && { compraMaterialItemId }),
      },
    }),

  excluirItem: ({ id, itemId }) =>
    AxiosGlobalFilters({
      method: 'DELETE',
      url: `/v1/solicitacoes-materiais/${id}/itens/${itemId}`,
      headers: headers(),
    }),

  // Andamentos
  criarAndamento: ({ id, status, responsavelSaidaMaterialId, responsavelRetiradaId, data, motivoNegativa, itens }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: `/v1/solicitacoes-materiais/${id}/andamentos`,
      headers: headers(),
      data: {
        status,
        data,
        ...(responsavelSaidaMaterialId && { responsavelSaidaMaterialId }),
        ...(responsavelRetiradaId && { responsavelRetiradaId }),
        ...(motivoNegativa && { motivoNegativa }),
        ...(itens && { itens }),
      },
    }),

  listarHistorico: ({ id, page = 1, pageSize = 50 }) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: `/v1/solicitacoes-materiais/${id}/historico`,
      headers: headers(),
      params: { page, pageSize },
    }),
};
